[].forEach.call(document.querySelectorAll("nav .nav-link"), function (element) {
	var loc = window.location;
	if (loc == element.href)
		element.classList.add("active");
});
